import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppService } from '../../app.service';
import { IConfigService } from '../../config/iconfigservice';
import { AccountEvent } from '../../models';
import { BaseService } from '@Services/base.service';

export interface TimerEventCaseCountRequest {
    tenantId: string;
    searchDaysBack: string;
    statuses: string[];
    minSearchDaysBack?: string;
    dateFieldMapkey?: string;
}

export interface TimerEventCaseCountResponse {
    caseCount: number;
    searchDaysBack: number;
    maxCasesPerRun: number;
}

@Injectable()
export class AccountEventsService extends BaseService {

    publicApiBaseUrl: string;

    constructor(appService: AppService, configService: IConfigService, httpClient: HttpClient) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    getAccountEvents(accountId: string) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/config/account/${accountId}/events`;

        return super.getData<AccountEvent[]>(url, clientId);
    }

    addAccountEvent(accountEvent: AccountEvent) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/config/account/${accountEvent.accountId}/events`;

        return super.postData(url, accountEvent, clientId);
    }

    editAccountEvent(accountEvent: AccountEvent) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/config/account/${accountEvent.accountId}/events`;

        return super.putData(url, accountEvent, clientId);
    }

    deleteAccountEvent(accountEvent: AccountEvent) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/config/account/${accountEvent.accountId}/events/${accountEvent.id}`;

        return super.deleteData(url, clientId);
    }

    /**
     * Asks production how many cases a timer event configuration would pick up. Used to warn a configurer before they
     * save a search window that would take many hours to work through.
     */
    getTimerEventCaseCount(accountId: string, request: TimerEventCaseCountRequest) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/config/account/${accountId}/events/timer/caseCount`;

        return super.postData<TimerEventCaseCountResponse>(url, request, clientId);
    }

    getAccountEventMessage(accountId: any, id: any) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/config/account/${accountId}/events/message/${id}`;

        return super.getData<any>(url, clientId);
    }
}
